<template>
    <v-container fluid class="align-center column" style="height: auto">
        <div class="path align-center">
            <div class="row screen-width" style="height: 24px; gap: 24px">
                <HomeOutline :size="24"></HomeOutline>
                <ChevronRight :size="24"></ChevronRight>
                <p>기술자료실</p>
                <ChevronRight :size="24"></ChevronRight>
                <p>보험</p>
            </div>
        </div>

        <div class="column screen-width" style="padding: 40px 0px; gap: 40px">
            <p style="font-size: 32px; font-wieght: bold">
                New Navico 구독 서비스 | 3년 30만원으로 수리부터 교환까지
            </p>
            <div class="two-grid">
                <product-explan-item
                    :imageSrc="require('@/assets/img/qna.avif')"
                    :imageSize="116"
                    :title="'제목이 들어갑니다'"
                    :content="'상세내용'"
                >
                </product-explan-item
                ><product-explan-item
                    :imageSrc="require('@/assets/img/qna.avif')"
                    :imageSize="116"
                    :title="'제목이 들어갑니다'"
                    :content="'상세내용'"
                >
                </product-explan-item>
                <product-explan-item
                    :imageSrc="require('@/assets/img/qna.avif')"
                    :imageSize="116"
                    :title="'제목이 들어갑니다'"
                    :content="'상세내용'"
                >
                </product-explan-item
                ><product-explan-item
                    :imageSrc="require('@/assets/img/qna.avif')"
                    :imageSize="116"
                    :title="'제목이 들어갑니다'"
                    :content="'상세내용'"
                >
                </product-explan-item>
                <product-explan-item
                    :imageSrc="require('@/assets/img/qna.avif')"
                    :imageSize="116"
                    :title="'제목이 들어갑니다'"
                    :content="'상세내용'"
                >
                </product-explan-item
                ><product-explan-item
                    :imageSrc="require('@/assets/img/qna.avif')"
                    :imageSize="116"
                    :title="'제목이 들어갑니다'"
                    :content="'상세내용'"
                >
                </product-explan-item>
            </div>
        </div>
    </v-container>
</template>

<script>
import HomeOutline from "vue-material-design-icons/HomeOutline.vue";
import ChevronRight from "vue-material-design-icons/ChevronRight.vue";
import ProductExplanItem from "@/components/ProductExplanItem.vue";
import { ref, onMounted, computed } from "vue";
import { useStore } from "vuex";

export default {
    name: "product-layout",
    components: { HomeOutline, ChevronRight, ProductExplanItem },
    setup() {
        const doAddProduct = ref(false);
        const searchProductName = ref("");
        const products = ref([
            // 기본 상품 리스트
            { id: 1, name: "상품 1", price: 10000 },
            { id: 2, name: "상품 2", price: 20000 },
            { id: 3, name: "상품 3", price: 30000 },
            { id: 4, name: "상품 4", price: 40000 },
            { id: 5, name: "상품 5", price: 50000 },
            { id: 6, name: "상품 6", price: 60000 },
        ]);
        const productInfo = ref({});
        const store = useStore();

        const getProduct = computed(() => {
            return store.getters.getProductList;
        });

        const searchProduct = () => {
            if (searchProductName.value != "") {
                store.dispatch("searchProduct", searchProductName.value);
            } else {
                store.dispatch("getProductList");
            }
        };

        const updateProduct = (product) => {
            productInfo.value = product;
            doAddProduct.value = true;
        };

        const deleteProduct = (product) => {
            store.dispatch("deleteProduct", product.id);
        };

        onMounted(() => {
            store.dispatch("getProductList");
        });

        return {
            store,
            searchProductName,
            productInfo,
            products,
            doAddProduct,
            getProduct,
            deleteProduct,
            updateProduct,
            searchProduct,
        };
    },
};
</script>

<style scoped>
.search-container {
    position: fixed;
    top: 30px;
    right: 10px;
    width: 300px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.input-form {
    width: 70%;
    border: 1px solid black;
    background: white;
    height: 90%;
    margin: 10px;
    text-indent: 15px;
}

.speed-dial {
    position: fixed;
    bottom: 0;
    right: 0;
}

button {
    margin: 10px;
}

.align-center {
    display: flex;
    justify-content: center;
    align-items: center;
}

.align-left {
    display: flex;
    justify-content: start;
    align-items: center;
}

@keyframes blink {
    0% {
        background-color: #2196f3;
    }
    50% {
        background-color: white;
    }
}

/* for Chrome, Safari */
@-webkit-keyframes blink {
    0% {
        background-color: #2196f3;
    }
    50% {
        background-color: white;
    }
}

/* blink CSS 브라우저 별로 각각 애니메이션을 지정해 주어야 동작한다. */
.blinkcss {
    font-weight: bold;
    background: #2196f3;
    color: white;
    /* animation: blink 1s infinite;
  -webkit-animation: blink 1s infinite; */
}

.full-size {
    width: 100%;
    height: 100%;
}

div {
    -webkit-text-size-adjust: 10%; /* 크롬, 사파리, 오페라 신버전 */
    -ms-text-size-adjust: none; /* IE */
}

.sensor-title {
    font-size: 0.875rem;
    width: 100%;
    min-width: 80px;
    color: black;
    height: 33%;
}

.sensor-value {
    padding: 20px;
    font-size: 1.25rem;
    width: 100%;
    height: 67%;
}

/* 화면 너비가 601px에서 900px 사이인 경우 */
@media (min-height: 601px) and (max-height: 850px) {
    .sensor-title {
        font-size: 0.675rem;
        padding: 2px 15px;
    }

    .sensor-value {
        padding: 5px 15px;
        font-size: 1rem;
    }
}
.search-bar {
    height: 60px;
    display: flex;
}
.search-bar input {
    padding: 8px;
    width: 200px;
}
.search-bar button {
    padding: 8px;
}
.add-product {
    height: 40px;
    cursor: pointer;
}
.product-list {
    width: 100%;
    height: calc(100% - 70px);
    display: flex;
    flex-wrap: wrap;
}
.product-card {
    color: white;
    width: 20%;
    aspect-ratio: 1 / 1;
    padding: 30px 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.product-image {
    width: 100%;
    height: 70%;
    background-color: #444;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
}
.product-info {
    width: 100%;
    height: 70px;
    color: black;
    padding: 10px;
    /* text-align: center; */
}
.product-btn {
    width: 100%;
    height: 50px;
    padding: 10px;
    display: flex;
    justify-content: space-between;
}

.two-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr); /* 한 줄에 2개 */
    gap: 16px;
}
</style>
